import React, { useState, useEffect } from "react";
import "./NewuserProfile.css";
import NavBar from "../../components/NavBar/NavBar";
import AddAddress from "../Shipping/Shipping";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import NewOrderTracking from "../OrderHistory/OrderTracking/NewOrderTraking";

const NewuserProfile = () => {
  const [activeTab, setActiveTab] = useState("accountDetails");
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    isEmailVerified: false,
  });
  const [emailEdited, setEmailEdited] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [userId, setUserId] = useState("");
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const location = useLocation();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          "https://riymay.com/api/v1/user/getuserdetails",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setUserData(data.user);
          setUserId(data.user._id);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://riymay.com/api/v1/user/update/user-info/profile", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify({
          userId,
          firstName: userData.firstName,
          lastName: userData.lastName,
          phone: userData.phone,
        }),
      });
      if (response.ok) {
        toast.success("Profile updated successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          toastId: "updateSuccess",
        });
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleEmailChange = (e) => {
    setUserData({ ...userData, email: e.target.value });
    setEmailEdited(true);
    setVerificationMessage("");
  };

  const sendVerificationEmail = async () => {
    try {
      const response = await fetch("https://riymay.com/api/v1/user/update/user-info/email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify({ userId, email: userData.email }),
      });
      const data = await response.json();
      if (response.ok) {
        setVerificationMessage("Verification email sent! Check your inbox.");
      } else {
        setVerificationMessage(data.message || "Error sending verification email.");
      }
    } catch (error) {
      console.error("Error sending verification email:", error);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error("New passwords do not match.", { position: "top-right", autoClose: 3000, theme: "colored" });
      return;
    }
    try {
      const response = await fetch("https://riymay.com/api/v1/user/update/user-info/password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify({
          userId,
          currentPassword: passwordData.currentPassword,
          newPassword: passwordData.newPassword,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success("Password updated successfully!", { position: "top-right", autoClose: 3000, theme: "colored" });
        setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
      } else {
        toast.error(data.message || "Error updating password.", { position: "top-right", autoClose: 3000, theme: "colored" });
      }
    } catch (error) {
      console.error("Error updating password:", error);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "accountDetails":
        return (
          <div className="tab-content">
            <form className="account-form" onSubmit={handleProfileUpdate}>
              <label>
                First Name:
                <input
                  type="text"
                  value={userData.firstName}
                  onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
                />
              </label>
              <label>
                Last Name:
                <input
                  type="text"
                  value={userData.lastName}
                  onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
                />
              </label>
              <label>
                Email:
                <input
                  type="email"
                  value={userData.email}
                  onChange={handleEmailChange}
                />
                {emailEdited && (
                  <button type="button" onClick={sendVerificationEmail}>
                    Verify
                  </button>
                )}
                {verificationMessage && <span>{verificationMessage}</span>}
              </label>
              <label>
                Phone:
                <input
                  type="text"
                  value={userData.phone}
                  onChange={(e) => setUserData({ ...userData, phone: e.target.value })}
                  maxLength={10}
                />
              </label>
              <button type="submit">Save Changes</button>
            </form>
          </div>
        );
      case "orders":
        return (
          <div className="tab-content">
            <NewOrderTracking />
          </div>
        );
      case "addresses":
        return (
          <div className="tab-content">
            <p className="nodata-label" style={{ padding: '40px 0' }}>No saved addresses</p>
            <p className="nodata-sub">Your shipping address will be saved when you place an order.</p>
          </div>
        );
      case "password":
        return (
          <div className="tab-content">
            <p className="nodata-sub" style={{ marginBottom: '24px' }}>To change your password, use the link below. You'll receive an email to reset it.</p>
            <a href="/forgot-password" className="nodata-btn">Reset Password</a>
          </div>
        );
      case "wishlist":
        return (
          <div className="tab-content">
            <p className="nodata-label" style={{ padding: '40px 0' }}>Your wishlist is empty</p>
            <p className="nodata-sub">Save items you love and find them here.</p>
          </div>
        );
      default:
        return (
          <div className="tab-content">
            <h2>Welcome to your account!</h2>
          </div>
        );
    }
  };

  return (
    <>
      <div className="account-dashboard">
        <h1 className="title">MY ACCOUNT</h1>
        <div className="dashboard-container">
          <div className="sidebar">
            <ul>
              <h3>{userData.firstName}</h3>
              <li className={activeTab === "accountDetails" ? "active" : ""} onClick={() => setActiveTab("accountDetails")}>
                Account Details
              </li>
              <li className={activeTab === "orders" ? "active" : ""} onClick={() => setActiveTab("orders")}>
                Orders
              </li>
              <li className={activeTab === "addresses" ? "active" : ""} onClick={() => setActiveTab("addresses")}>
                Addresses
              </li>
              <li className={activeTab === "wishlist" ? "active" : ""} onClick={() => setActiveTab("wishlist")}>
                Wishlist
              </li>
              <li className={activeTab === "password" ? "active" : ""} onClick={() => setActiveTab("password")}>
                Change Password
              </li>
            </ul>
          </div>
          <div className="main-content">{renderContent()}</div>
        </div>
      </div>
    </>
  );
};

export default NewuserProfile;
